import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { NextAppointmentCellComponent } from './next-appointment-cell.component';

@NgModule({
  declarations: [NextAppointmentCellComponent],
  imports: [CommonModule, TooltipModule],
  exports: [NextAppointmentCellComponent],
})
export class NextAppointmentCellModule {}
